module.exports = __webpack_public_path__ + "static/media/ball.785aafdf.gif";